// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"639":"fc6c17d6","865":"6b301f8e"}[chunkId] + ".chunk.js";
};